__turbopack_context__.v({
  "badgeButton": "-mAQuW_badgeButton",
  "badgeEmpty": "-mAQuW_badgeEmpty",
  "count": "-mAQuW_count",
  "cover": "-mAQuW_cover",
  "coverHat": "-mAQuW_coverHat",
  "dot": "-mAQuW_dot",
  "group": "-mAQuW_group",
  "hat": "-mAQuW_hat",
  "hatActive": "-mAQuW_hatActive",
  "hatEmpty": "-mAQuW_hatEmpty",
  "hatOn": "-mAQuW_hatOn",
  "invite": "-mAQuW_invite",
  "inviteActions": "-mAQuW_inviteActions",
  "inviteBody": "-mAQuW_inviteBody",
  "inviteTitle": "-mAQuW_inviteTitle",
  "link": "-mAQuW_link",
  "notNow": "-mAQuW_notNow",
  "row": "-mAQuW_row",
  "stats": "-mAQuW_stats",
  "tag": "-mAQuW_tag",
  "tile": "-mAQuW_tile",
  "tileActive": "-mAQuW_tileActive",
  "tiles": "-mAQuW_tiles",
});
